import i18next from 'i18next';

export function getGroupName(
    allGroups?: {groupId: string; title?: string}[],
    groupId?: string,
    unknownRoomTranslationKey: Parameters<typeof i18next.t>[0] = 'unknown',
): string {
    return allGroups?.find(group => group.groupId === groupId)?.title ?? i18next.t(unknownRoomTranslationKey);
}
